import { render, staticRenderFns } from "./UpgradeIcon.vue?vue&type=template&id=60376a0b&scoped=true"
import script from "./UpgradeIcon.vue?vue&type=script&lang=js"
export * from "./UpgradeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60376a0b",
  null
  
)

export default component.exports